import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('v-api2-middleware', wrap(Vue, () => import('~root/./src/ui_components/api2_middleware/Api2Middleware.vue?shadow')))

window.customElements.define('v-api2-middleware-simple', wrap(Vue, () => import('~root/./src/ui_components/api2_middleware/Api2MiddlewareSimple.vue?shadow')))

window.customElements.define('v-account-to-account', wrap(Vue, () => import('~root/./src/ui_components/v_account_to_account/AccountToAccount.vue?shadow')))

window.customElements.define('v-aux', wrap(Vue, () => import('~root/./src/ui_components/v_aux/Aux.vue?shadow')))

window.customElements.define('v-binary-view', wrap(Vue, () => import('~root/./src/ui_components/v_binary_view/BinaryView.vue?shadow')))

window.customElements.define('v-buy-product', wrap(Vue, () => import('~root/./src/ui_components/v_buy_product/BuyProduct.vue?shadow')))

window.customElements.define('v-cart', wrap(Vue, () => import('~root/./src/ui_components/v_cart/Cart.vue?shadow')))

window.customElements.define('v-catalog', wrap(Vue, () => import('~root/./src/ui_components/v_catalog/Catalog.vue?shadow')))

window.customElements.define('v-catalog-ext', wrap(Vue, () => import('~root/./src/ui_components/v_catalog_ext/CatalogExt.vue?shadow')))

window.customElements.define('v-child-placement', wrap(Vue, () => import('~root/./src/ui_components/v_child_placement/ChildPlacement.vue?shadow')))

window.customElements.define('v-condition', wrap(Vue, () => import('~root/./src/ui_components/v_condition/Condition.vue?shadow')))

window.customElements.define('v-condition3', wrap(Vue, () => import('~root/./src/ui_components/v_condition3/Condition3.vue?shadow')))

window.customElements.define('v-currency-rate', wrap(Vue, () => import('~root/./src/ui_components/v_currency_rate/CurrencyRate.vue?shadow')))

window.customElements.define('v-distribution-settings', wrap(Vue, () => import('~root/./src/ui_components/v_distribution_settings/DistributionSettings.vue?shadow')))

window.customElements.define('v-downline-grid', wrap(Vue, () => import('~root/./src/ui_components/v_downline_grid/DownlineGrid.vue?shadow')))

window.customElements.define('v-frontline', wrap(Vue, () => import('~root/./src/ui_components/v_frontline/Frontline.vue?shadow')))

window.customElements.define('v-frontline-invoices', wrap(Vue, () => import('~root/./src/ui_components/v_frontline_invoices/FrontlineInvoices.vue?shadow')))

window.customElements.define('v-genealogy-grid', wrap(Vue, () => import('~root/./src/ui_components/v_genealogy_grid/GenealogyGrid.vue?shadow')))

window.customElements.define('v-leader-board', wrap(Vue, () => import('~root/./src/ui_components/v_leader_board/LeaderBoard.vue?shadow')))

window.customElements.define('v-login', wrap(Vue, () => import('~root/./src/ui_components/v_login/Login.vue?shadow')))

window.customElements.define('v-matrix-view', wrap(Vue, () => import('~root/./src/ui_components/v_matrix_view/MatrixView.vue?shadow')))

window.customElements.define('v-metric-widget', wrap(Vue, () => import('~root/./src/ui_components/v_metric_widget/MetricWidget.vue?shadow')))

window.customElements.define('v-metrics', wrap(Vue, () => import('~root/./src/ui_components/v_metrics/Metrics.vue?shadow')))

window.customElements.define('v-metrics-history', wrap(Vue, () => import('~root/./src/ui_components/v_metrics_history/MetricsHistory.vue?shadow')))

window.customElements.define('v-mini-cart', wrap(Vue, () => import('~root/./src/ui_components/v_mini_cart/MiniCart.vue?shadow')))

window.customElements.define('v-__-mini-cart', wrap(Vue, () => import('~root/./src/ui_components/v_mini_cart/__MiniCart.vue?shadow')))

window.customElements.define('v-online-order', wrap(Vue, () => import('~root/./src/ui_components/v_online_order/OnlineOrder.vue?shadow')))

window.customElements.define('v-online-order-history', wrap(Vue, () => import('~root/./src/ui_components/v_online_order_history/OnlineOrderHistory.vue?shadow')))

window.customElements.define('v-payout-request', wrap(Vue, () => import('~root/./src/ui_components/v_payout_request/PayoutRequest.vue?shadow')))

window.customElements.define('v-product', wrap(Vue, () => import('~root/./src/ui_components/v_product/Product.vue?shadow')))

window.customElements.define('v-purchase-pack', wrap(Vue, () => import('~root/./src/ui_components/v_purchase_pack/PurchasePack.vue?shadow')))

window.customElements.define('v-ref-link', wrap(Vue, () => import('~root/./src/ui_components/v_ref_link/RefLink.vue?shadow')))

window.customElements.define('v-register-member', wrap(Vue, () => import('~root/./src/ui_components/v_register_member/RegisterMember.vue?shadow')))

window.customElements.define('v-registration', wrap(Vue, () => import('~root/./src/ui_components/v_registration/Registration.vue?shadow')))

window.customElements.define('v-report', wrap(Vue, () => import('~root/./src/ui_components/v_report/Report.vue?shadow')))

window.customElements.define('v-schedule-history', wrap(Vue, () => import('~root/./src/ui_components/v_schedule_history/ScheduleHistory.vue?shadow')))

window.customElements.define('v-transaction-log', wrap(Vue, () => import('~root/./src/ui_components/v_transaction_log/TransactionLog.vue?shadow')))

window.customElements.define('v-tree-chart', wrap(Vue, () => import('~root/./src/ui_components/v_tree_chart/TreeChart.vue?shadow')))

window.customElements.define('v-user-details-popup', wrap(Vue, () => import('~root/./src/ui_components/v_user_details_popup/UserDetailsPopup.vue?shadow')))

window.customElements.define('v-user-menu', wrap(Vue, () => import('~root/./src/ui_components/v_user_menu/UserMenu.vue?shadow')))

window.customElements.define('v-user-pop', wrap(Vue, () => import('~root/./src/ui_components/v_user_pop/UserPop.vue?shadow')))

window.customElements.define('v-user-profile', wrap(Vue, () => import('~root/./src/ui_components/v_user_profile/UserProfile.vue?shadow')))

window.customElements.define('v-user-profile3', wrap(Vue, () => import('~root/./src/ui_components/v_user_profile3/UserProfile3.vue?shadow')))

window.customElements.define('v-wallet-balance', wrap(Vue, () => import('~root/./src/ui_components/v_wallet_balance/WalletBalance.vue?shadow')))

window.customElements.define('v-wallet-history', wrap(Vue, () => import('~root/./src/ui_components/v_wallet_history/WalletHistory.vue?shadow')))

window.customElements.define('v-withdrawals-history', wrap(Vue, () => import('~root/./src/ui_components/v_withdrawals_history/WithdrawalsHistory.vue?shadow')))